/**
 * Fuel (GDD §4.3; concept L1204–L1206): a full tank lasts 36 s; flying over a barge refuels at 75% per second while
 * the jet overlaps it (the barge's box plus 2 m, master plan judgment call 4). Shooting a barge destroys that source.
 */
import { config } from '../core/config.ts';
import type { GameSim } from '../sim/context.ts';

/** Overlap padding around a barge (concept L1205). */
const PAD = 2;

export function stepFuel(sim: GameSim, dt: number): void {
  const run = sim.run;
  const f = config.fuel;
  const jet = sim.jet;
  run.fuel -= dt * f.drainPerSec;
  const ents = sim.ents;
  for (let i = 0; i < ents.count; i++) {
    const e = ents.items[i];
    if (!e || e.type !== 'fuel' || e.dying > 0) continue;
    if (Math.abs(jet.x - e.x) < e.hw + PAD && Math.abs(jet.z - e.z) < e.hl + PAD)
      run.fuel = Math.min(1, run.fuel + dt * f.refuelPerSec);
  }
  run.fuel = Math.max(0, run.fuel);
}

/** True while the jet overlaps a live barge (the refuel tone, GDD §9). */
export function refueling(sim: GameSim): boolean {
  const jet = sim.jet;
  const ents = sim.ents;
  for (let i = 0; i < ents.count; i++) {
    const e = ents.items[i];
    if (
      e &&
      e.type === 'fuel' &&
      e.dying <= 0 &&
      Math.abs(jet.x - e.x) < e.hw + PAD &&
      Math.abs(jet.z - e.z) < e.hl + PAD
    )
      return true;
  }
  return false;
}
